import { ApplicationIdentifier } from '@evorait/pace-components';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable, of } from 'rxjs';
import { BarcodeScannerModalComponent } from '../../components/barcode-scanner-modal/barcode-scanner-modal.component';
import { ModalClass } from '../../enums/modal-bootstrap-classes.enum';
import { BarcodeScanResult } from './barcode-scanner.const';

/**
 * Opens the barcode scanner modal and returns its scan result. Shared by every
 * {@link BarcodeScannerInterface} implementation's `scan()`: opening the modal is pure UI
 * orchestration and has to hand the caller back the result observable synchronously, so it cannot
 * live in the store and is kept here rather than duplicated.
 *
 * @param modalService the modal service to open the scanner modal with
 * @param options the modal's initial state
 * @param options.pattern an optional pattern the scanned/entered text is expected to match
 * @param options.appId the application identifier the scan is performed for
 * @param options.clipboardAccessible whether the clipboard of previously scanned barcodes may
 * be opened from the modal
 * @returns an observable emitting the scan result once the modal completes
 */
export function openBarcodeScannerModal(
    modalService: BsModalService,
    options: { pattern?: string; appId: ApplicationIdentifier; clipboardAccessible: boolean },
): Observable<BarcodeScanResult> {
    const modalInstance = modalService.show(BarcodeScannerModalComponent, {
        backdrop: 'static',
        class: ModalClass.MODAL_MEDIUM,
        initialState: options,
        ariaLabelledBy: 'barcode-scanner-modal-title',
    });

    return modalInstance.content?.scanCompleted.asObservable() ?? of({ text: '', format: '' });
}
